export default __webpack_public_path__ + "static/media/riverrun.7814c49e.jpg";